import type {
  ICalculatorSubmittedEvent,
  ICalculatorSubmittedInput,
} from '../types/clickEvents';

const calculatorSubmitted = (
  input: ICalculatorSubmittedInput,
): Omit<ICalculatorSubmittedEvent, 'event'> => ({
  linkDetails: input.linkDetails ?? { linkName: '' },
  financeCalculator: input.financeCalculator,
  module: input.moduleName ? { moduleName: input.moduleName } : undefined,
});

export default calculatorSubmitted;
